module.exports = __webpack_public_path__ + "static/img/week.13846a45.png";